/**
 * Represents the status of a duplicate rebate record.
 */
export enum RebateRecordDuplicateStatusModel {
	/**
	 * The duplicate rebate record has been approved.
	 */
	Approved = 1,
	/**
	 * The duplicate rebate record has been deleted.
	 */
	Deleted = 2
}
